// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".holidays-alert[data-v-7da7203a]{position:relative;padding-bottom:25px}.holidays-alert__created-label[data-v-7da7203a]{font-size:10px;position:absolute;right:5px;bottom:5px}.holidays-alert__edit-delete-panel[data-v-7da7203a]{position:absolute;right:5px;top:5px;font-size:21px}\n", ""]);
// Exports
module.exports = exports;
